import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { Event } from '../interfaces/events';

export interface EventsParam {
	start_date?: string;
	end_date?: string;
	fk_devices: string[];
	fk_event_types?: string[];
}

function eventQueryBuilder(params: EventsParam): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.start_date) {
		queryParams.append('start_date', params.start_date);
	}
	if (params.end_date) {
		queryParams.append('end_date', params.end_date);
	}
	if (params.fk_event_types && params.fk_event_types.length > 0) {
		for (const fkEventType of params.fk_event_types) {
			queryParams.append('fk_event_type', fkEventType);
		}
	}
	if (params.fk_devices && params.fk_devices.length > 0) {
		for (const fkDevice of params.fk_devices) {
			queryParams.append('fk_device', fkDevice);
		}
	}
	return queryParams;
}

async function getEvents(params: EventsParam): Promise<Event[]> {
	const queryParams = eventQueryBuilder(params);
	try {
		const response = await axios.get<Envelope<Event[]>>(`events`, { params: queryParams });
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function getEventsDevice(deviceId: number, params: EventsParam): Promise<Event[]> {
	try {
		const queryParams = eventQueryBuilder(params);
		const response = await axios.get<Envelope<Event[]>>(`events/${deviceId}`, {
			params: queryParams,
		});
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function getEventsLast(params: EventsParam): Promise<Event[]> {
	try {
		const queryParams = eventQueryBuilder(params);
		const response = await axios.get<Envelope<Event[]>>(`events/last`, {
			params: queryParams,
		});
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const events = {
	getEvents,
	getEventsDevice,
	getEventsLast,
};
